import { render, staticRenderFns } from "./customFilter.vue?vue&type=template&id=685d97c6&scoped=true"
import script from "./customFilter.vue?vue&type=script&lang=js"
export * from "./customFilter.vue?vue&type=script&lang=js"
import style0 from "./customFilter.vue?vue&type=style&index=0&id=685d97c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d97c6",
  null
  
)

export default component.exports